import React from 'react';
import { TableSortLabel } from '@mui/material';
import type { MedicalRecordsSort } from '../data/medicalRecordsViews';

export const MedicalRecordsSortControl: React.FC<{
  field: string;
  children: React.ReactNode;
  value: MedicalRecordsSort;
  onChange: (value: MedicalRecordsSort) => void;
}> = ({ field, children, value, onChange }) => (
  <TableSortLabel active={value.field === field} hideSortIcon={false}
    direction={value.field === field && value.descending ? 'desc' : 'asc'}
    onClick={() => onChange({ field, descending: value.field === field && !value.descending })}>
    {children}
  </TableSortLabel>
);
